module.exports = __webpack_public_path__ + "front/img/13.2f90cea8.jpg";